import { getColorByDayName } from '../utils';
import { type StudentDayStats, type UIStudentDailyAchievement } from '../../model';
import { getPercetageValue } from '../../utils';

/**
 * Return students weekly achievement and target by adding up each day goal
 */
export const getStudentWeeklyAchievementsTotal = (
  data: Record<string, StudentDayStats> | undefined,
  todaysGoal: number | undefined | null
) => {
  const weeklyTarget = (todaysGoal ?? 2) * 5;

  if (!data) {
    return {
      actual: 0,
      target: weeklyTarget,
    };
  }

  const daysData = Object.values(data);

  let weeklyActual = 0;

  for (const day of daysData) {
    weeklyActual += day.actual ?? 0;
  }

  return {
    actual: weeklyActual,
    target: weeklyTarget,
  };
};

/**
 * Return bar graph for each day
 */
export const getStudentDailyAchievementsForWeek = (
  data: Record<string, StudentDayStats> | undefined,
  rulerSize: number
): Array<UIStudentDailyAchievement> => {
  const results: Array<UIStudentDailyAchievement> = [];

  if (!data) {
    return results;
  }

  const days = Object.keys(data);

  for (const day of days) {
    const { actual } = data[day];
    const progress = getPercetageValue(rulerSize, actual, true);

    // Don't add graphs with 0 width
    if (progress <= 0) {
      continue;
    }

    results.push({
      day,
      lessonsCompleted: actual,
      progress: getPercetageValue(rulerSize, actual, true),
      color: getColorByDayName(day),
    });
  }

  return results;
};
